import React, { Fragment } from 'react'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers'

function refreshPage() {
  window.location.reload(false)
}
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

export default function NotificationForm() {
  const classes = useStyles()
  const [selectedDate, setSelectedDate] = React.useState(Date.now())
  const [title, setTitle] = React.useState('')
  const [body, setBody] = React.useState('')

  const handleDateChange = (date) => {
    setSelectedDate(date)
  }

  return (
    <Fragment>
      <Container component='main' maxWidth='md'>
        <div className={classes.paper}>
          <Typography component='h1' variant='h4'>
            Bildirim Gönder
          </Typography>
          <form className={classes.form}>
            <TextField
              variant='outlined'
              margin='normal'
              required
              fullWidth
              id='notification_title'
              label='Başlık'
              name='notification_title'
              autoFocus
              onInput={(e) => setTitle(e.target.value)}
            />

            <TextField
              variant='outlined'
              margin='normal'
              required
              fullWidth
              id='notification'
              label='Bildirim'
              name='notification'
              autoFocus
              multiline
              rows={4}
              onInput={(e) => setBody(e.target.value)}
            />

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container justify='space-around'>
                <KeyboardDatePicker
                  margin='normal'
                  id='date-picker-dialog'
                  label='Date picker dialog'
                  format='dd/MM/yyyy'
                  value={selectedDate}
                  onChange={handleDateChange}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  disablePast
                />
                <KeyboardTimePicker
                  margin='normal'
                  id='time-picker'
                  label='Time picker'
                  value={selectedDate}
                  onChange={handleDateChange}
                  KeyboardButtonProps={{
                    'aria-label': 'change time',
                  }}
                  ampm={false}
                />
              </Grid>
            </MuiPickersUtilsProvider>

            <Button
              type='submit'
              fullWidth
              variant='contained'
              color='primary'
              className={classes.submit}
              onClick={async (e) => {
                e.preventDefault()
                let notificationObject = {
                    "app_id": "b1441a8b-d378-42e8-8ffc-1169d826e4d1",
                    "included_segments": ["All"],
                    "contents": {"en": `${body}`},
                    "headings": {"en": `${title}`},
                    "send_after": `${selectedDate}`
                  }
                  
                const rawResponse = await fetch('https://onesignal.com/api/v1/notifications', {
                  method: 'POST',
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic MGI5ODc5MDUtZWNlMy00YzU1LWFiZmEtNWZhNmY3YzVmMTZl'
                  },
                  body: JSON.stringify(notificationObject)
                });
                const content = await rawResponse.json();

                console.log(content);
                
                await sleep(1000)
                refreshPage()
              }}
            >
              Gönder
            </Button>
          </form>
        </div>
      </Container>
    </Fragment>
  )
}
